import { useParams, useSearchParams } from "react-router-dom";
import { useServices } from "../../services/Services";
import { checkEnv } from "../../helper/helper";
import PublicEventContent from "../../components/PublicEvent/PublicEventContent";
import useIsEmbedded from "../../hooks/useIsEmbedded";
import PublicUserCallToAction from "../../components/PublicUserCallToAction/PublicUserCallToAction";

const backendApiUrl = import.meta.env.VITE_BACKEND_API_URL;
checkEnv(backendApiUrl, "VITE_BACKEND_API_URL");

const PublicEventPage: React.FC = () => {
  const services = useServices();
  const isEmbedded = useIsEmbedded();

  const { eventId } = useParams<{
    eventId: string;
  }>();
  const safeEventId = eventId ?? "";

  const [searchParams] = useSearchParams();
  const rawAccentColor = searchParams.get("accentColor");

  const isValidHex = (color: string) => /^#?[0-9A-F]{6}$/i.test(color);

  let accentColor: string | undefined = undefined;
  if (rawAccentColor && isValidHex(rawAccentColor)) {
    accentColor = rawAccentColor.startsWith("#")
      ? rawAccentColor
      : `#${rawAccentColor}`;
  }

  const {
    data: event,
    isLoading,
    isError,
    error,
  } = services.Event.useGetPublicEventById(safeEventId);

  if (!eventId) {
    return <div>Event ID is required</div>;
  }

  if (!isEmbedded) {
    const content = (
      <PublicEventContent
        event={event}
        isLoading={isLoading}
        isError={isError}
        error={error as Error}
        accentColor={accentColor || undefined}
      />
    );
    return <PublicUserCallToAction type="public-event" content={content} />;
  }
  return (
    <PublicEventContent
      event={event}
      isLoading={isLoading}
      isError={isError}
      error={error as Error}
      accentColor={accentColor || undefined}
    />
  );
};

export default PublicEventPage;
